module.exports = __webpack_public_path__ + "static/media/DSC_2887.62eba345.jpg";